import React from "react";
import { Image } from "react-bootstrap";
import { RxCrossCircled } from "react-icons/rx";
import { FaCheckCircle } from "react-icons/fa";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import { Tooltip } from "antd";
import moment from "moment"

const CalendarComponent = ({
  currentMonth,
  rewardsActivityLogs,
  setDateNo,
  dateNo,
  setProducts,
  products,
  leadPop = false,
  setCurrentMonth = true,
  rewardsActivityLogsTime
  // isNoActivityLog,
}) => {


  const daysInMonth = () => {
    const firstDay = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      1
    );
    const lastDay = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      0
    );
    const days = [];

    const offset = firstDay.getDay();

    for (let i = 0; i < offset; i++) {
      days.push(null);
    }

    for (let day = firstDay; day <= lastDay; day.setDate(day.getDate() + 1)) {
      days.push(new Date(day));
    }

    return days;
  };

  const renderDays = (rewardsActivityLogs) => {
    const days = daysInMonth();
    const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return (
      <div>
        <div className="dayNames">
          {dayNames.map((dayName) => (
            <div key={dayName} className="dayName">
              {dayName}
            </div>
          ))}
        </div>
        <div className="days">
          {days.map((day, index) =>{
            const dayNumber = moment(day).date();
            const logTime = rewardsActivityLogsTime?.[dayNumber]; 
            const formattedTime = logTime
  ? moment.utc(logTime).format("YYYY-MM-DD HH:mm:ss") 
  : null;
          return (
            <>
            <Tooltip
          title={day ? (formattedTime ? `Logged at ${formattedTime}` : "No logging") : ""}
              >
                  <div
                key={index}
                className={`${day ? "day" : ""} 
                ${
                  day !== null
                    ? rewardsActivityLogs[day && day.getDate()]?.length !== 0
                      ? "text-white bg-blue"
                      : "bg-grey"
                    : ""
                }
                ${day && dateNo === day.getDate() ? "day-bg" : ""}
                `}
                onClick={() => {
                  day && setProducts(rewardsActivityLogs[day && day.getDate()]);
                  setDateNo(day.getDate());
                }}
              >
                {day && day.getDate()}
              </div>
              </Tooltip>
            
            </>
          )
          } )}
        </div>
      </div>
    );
  };

  return (
    !isEmpty(rewardsActivityLogs) && (
      <div className="d-flex flex-column bg-white my-2 w-100 justify-content-center align-items-center">
        <div className="calendar">
          <div className="header">
            {leadPop ? (
              <div
                className="d-flex justify-content-between mx-4"
                style={{ width: "250px" }}
              >
                <div
                  onClick={() =>
                    setCurrentMonth(
                      new Date(
                        currentMonth.getFullYear(),
                        currentMonth.getMonth() - 1,
                        1
                      )
                    )
                  }
                  className="cursor-pointer"
                >
                  <ArrowLeftOutlined />
                </div>
                <div>
                  {currentMonth.toLocaleString("default", {
                    month: "long",
                    year: "numeric",
                  })}
                </div>
                <div
                  onClick={() =>
                    setCurrentMonth(
                      new Date(
                        currentMonth.getFullYear(),
                        currentMonth.getMonth() + 1,
                        1
                      )
                    )
                  }
                  className="cursor-pointer"
                >
                  <ArrowRightOutlined />
                </div>
              </div>
            ) : (
              <h4>
                {currentMonth.toLocaleString("default", {
                  month: "long",
                  year: "numeric",
                })}
              </h4>
            )}
          </div>
          {renderDays(rewardsActivityLogs)}
        </div>
        {leadPop?null:<div className={leadPop?"":"pt-2 d-flex gap-4 mt-2"}>
          {products?.length !== 0 ? (
            products?.map((prod) => {
              return (
                <div
                  className=" p-2 d-flex bg-white rounded shadow "
                  style={{
                    borderBottomColor: "#eee",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "1px",
                  }}
                >
                  <div
                  >
                    <Image
                      src={`${prod?.image_url?.cartImgUrl}`}
                      height="100px"
                      width="100px"
                    />
                  </div>
                  <div
                    style={{
                      width: "20%",
                    }}
                    className="d-flex flex-column justify-content-center mx-2"
                  >
                    <span>{prod?.name}</span>
                    <span>{prod?.Dosage}</span>
                  </div>
                  <div
                    style={{
                      width: "20%",
                    }}
                    className="d-flex align-items-center mx-1"
                  >
                    {prod?.eveningCheckIns && prod?.morningCheckIns ? (
                      <FaCheckCircle size={"10px"} color="#51AB51" />
                    ) : (
                      <RxCrossCircled size={"10px"} color="#414042" />
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center pt-4">No Log Found</div>
          )}
        </div>}
        {/* ) : (
        <div className="text-center pt-4">No Data Available</div>
      )} */}
      </div>
    )
  );
};

export default CalendarComponent;
